import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center","height":"24px","margin-bottom":"13px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"16px","font-weight":"500"} }, "地址详情", -1)
const _hoisted_4 = { style: {"flex":"1 1 0%","text-align":"right"} }
const _hoisted_5 = { class: "flex" }

interface MapItem {
  addressName: string
  addressTag?: number
  geoPoint: {
    latitude: number
    longitude: number
  }
  id?: number
}
interface CustomerMapItem {
  addressRefId: string
  addressRefName: string
  attrList: MapItem[]
}

import { ref, onMounted } from 'vue'
import {
  checkAddressValidate,
  checkAddressData,
  handleAddressAdd,
  handleAddressAddDel,
  clear
} from '@/hooks/addressArrValidate'
import { paramCodesDataFilter } from '@/utils/index'
import { listByParamCodes } from '@/api/common'
import { queryMapList, mapListSave } from '@/api/yuntuSales/customerCenter'
import MapModal from '@/components/MapModal/index.vue'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { cloneDeep } from 'lodash-es'
const __default__ = { name: 'DetailCard' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {

const paramCodeData = ref<any>({
  lbu_sign_in_address_label: []
})
const formRef = ref()
const form = ref<any>({
  attrList: []
})
const loading = ref<boolean>(false)
const visible = ref<boolean>(false)
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_sign_in_address_label']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = paramCodesDataFilter(res.data, 0)
    }
  })
}

const clearMainAddressFlag = (index: number) => {
  if (form.value.attrList) {
    for (const [i, item] of form.value.attrList.entries()) {
      if (index === i) {
        item.mainAddressFlag = item.mainAddressFlag === 1 ? 0 : 1
      } else {
        item.mainAddressFlag = 0
      }
    }
  }
}
// 查询客户地图详情
const fetch = (row: { addressRefId: string; addressRefName: string }) => {
  const { addressRefId, addressRefName } = row
  queryMapList({ addressRefId }).then((res) => {
    form.value = {
      addressRefId,
      addressRefName: addressRefName || '--',
      attrList: res.data && res.data.length ? res.data : [{}]
    }
  })
}
// 提交客户地图
const handleOk = () => {
  formRef.value?.validate().then((res: any) => {
    const p = cloneDeep(form.value)
    if (checkAddressData(form.value.attrList)) {
      DcMessage.error('签到地址不可重复！')
      return false
    }
    const { attrList } = p
    p.attrList = attrList.filter((item: MapItem) => item.addressName)
    loading.value = true
    mapListSave(p)
      .then((res) => {
        DcMessage.success('设置成功')
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
onMounted(() => {
  getByParamCodes()
})
const toggle = (row: CustomerMapItem) => {
  visible.value = !visible.value
  if (row.addressRefId) {
    fetch(row)
  }
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    loading: loading.value,
    title: "签到地址",
    width: "90%",
    height: "80%",
    onOk: handleOk,
    maskClosable: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: form.value,
        ref_key: "formRef",
        ref: formRef
      }, {
        default: _withCtx(() => [
          _createVNode(_component_dc_form_item, {
            label: "客户名称",
            span: 24,
            rules: {
          message: '请输入',
          required: true
        }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInput, {
                value: form.value.addressRefName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.addressRefName) = $event)),
                placeholder: "请输入",
                disabled: true
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_layout_card, { span: 10 }, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  (!_ctx.disabled)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        ghost: "",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(handleAddressAdd)(form.value.attrList)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(MultipleItem, {
                view: _ctx.view,
                line: false
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.attrList, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createVNode(_component_dc_form_item, {
                        label: index ? '' : '签到地址',
                        class: _normalizeClass(index ? 'no-form-label' : ''),
                        name: ['attrList', index, 'addressName'],
                        span: 8,
                        rules: [
            { validator: (rule, value) => _unref(checkAddressValidate)(rule, value, form.value.attrList, 'addressTag', '请选择') }
          ]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(MapModal, {
                            address: item.addressName,
                            "onUpdate:address": ($event: any) => ((item.addressName) = $event),
                            geoPoint: item.geoPoint,
                            "onUpdate:geoPoint": ($event: any) => ((item.geoPoint) = $event)
                          }, null, 8, ["address", "onUpdate:address", "geoPoint", "onUpdate:geoPoint"])
                        ]),
                        _: 2
                      }, 1032, ["label", "class", "name", "rules"]),
                      _createVNode(_component_dc_form_item, {
                        label: index ? '' : '补充地址',
                        class: _normalizeClass(index ? 'no-form-label' : ''),
                        name: ['attrList', index, 'suppAddress']
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInput, {
                            value: item.suppAddress,
                            "onUpdate:value": ($event: any) => ((item.suppAddress) = $event)
                          }, null, 8, ["value", "onUpdate:value"])
                        ]),
                        _: 2
                      }, 1032, ["label", "class", "name"]),
                      _createVNode(_component_dc_form_item, {
                        label: index ? '' : '地址类型',
                        class: _normalizeClass(index ? 'no-form-label' : ''),
                        span: 6,
                        name: ['attrList', index, 'addressTag'],
                        rules: [
            { validator: (rule, value) => _unref(checkAddressValidate)(rule, value, form.value.attrList, 'addressName', '请选择') }
          ]
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_ParamCodesSelect, {
                              options: paramCodeData.value.lbu_sign_in_address_label,
                              value: item.addressTag,
                              "onUpdate:value": ($event: any) => ((item.addressTag) = $event),
                              allowClear: ""
                            }, null, 8, ["options", "value", "onUpdate:value"]),
                            (form.value.attrList && form.value.attrList.length > 1)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  type: "text",
                                  danger: "",
                                  style: {"padding":"0 0 0 12px"},
                                  onClick: ($event: any) => (_unref(handleAddressAddDel)(index, form.value.attrList))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("删除")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_a_checkbox, {
                              style: {"padding":"3px 0 0 12px","width":"150px"},
                              checked: item.mainAddressFlag === 1,
                              onChange: ($event: any) => (clearMainAddressFlag(index))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("主要")
                              ]),
                              _: 2
                            }, 1032, ["checked", "onChange"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "class", "name", "rules"])
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 8, ["view"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "loading"]))
}
}

})